import { CompassCardUI } from '@scale/compass-ui/types';
import PercentageCardComponent from 'react-scale/corp/views/DataCompassCardsV2/transformation/PercentageCard/PercentageCardComponent';
import { faPercent } from '@fortawesome/pro-solid-svg-icons';
import {
  PercentageCardShared,
  type PercentageContextSchemaType,
  type PercentageContext,
  CalculationType,
  PERCENTAGE,
} from '@scale/genai-compass-shared/cards/percentage';

const defaultContext: PercentageContext = {
  cardType: PERCENTAGE,
  calculationType: CalculationType.PERCENTILE,
  selectedColumnIds: [],
};

export const PercentageCardInfo: CompassCardUI<PercentageContextSchemaType> = {
  ...PercentageCardShared,
  title: 'Percentile',
  icon: 'percent',
  toolTip: 'Calculate the percentiles of a column and append the results as a new column.',
  defaultContext,
  legacyComponent: PercentageCardComponent,
  button: {
    icon: faPercent,
  },
};
